import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs';
import { IContext } from '@context/models/context';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { ManagerDetails, ManagerDetailsArray } from '@manager-details/models/manager-details';

@Injectable()
export class ManagerDetailsHttpService {

  constructor(
    private readonly urlService: UrlBuilderService,
    private readonly http: HttpClient
  ) { }

  /**
   * Retrieves an array of manager details for a given context
   * @param context
   */
  getDetails(context: IContext): Observable<ManagerDetailsArray> {
    const url = this.urlService.getUrl('manager/details');
    return this.http
      .post<ManagerDetailsArray>(url, context).pipe(
        map(result => result || undefined)
      );
  }

  /**
   * Retrieves a single manager details object for a given manager coded
   * @param managerCode
   */
  getManagerDetails(managerCode: string): Observable<ManagerDetails> {
    const context = {
      ManagerCode: managerCode
    } as IContext;
    return this.getDetails(context).pipe(map(managers => managers.length > 0 ? managers[0] : undefined));
  }
  
}

